import {
  onBeforeMount, onBeforeUnmount, onMounted, ref,
} from 'vue';
import { track, trackCubeCustomEvent, trackSizeSelected } from '../tracking/trackingLayer';
import EventBus from '../../scripts/lib/EventBus.js';
import Groessenitem from './groessen-item.vue.component';

const templateElement = document.getElementById('groessen-layer-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  components: {
    Groessenitem,
  },

  props: {
    syan: {
      type: Number,
    },
    groessen: {
      type: Object,
    },
    artikelMap: {
      type: Object,
    },
    active: {
      type: Object,
    },
  },

  emits: ['bewerten:vue:artikel:changed'],

  setup(props) {
    const showLayer = ref(false);
    const doAdd2Cart = ref(false);
    const scrollPosition = ref(0);
    const drawer = ref(null);
    const sizeHeadlineRef = ref(null);

    function groesseSelected(articleId) {
      closeLayer();
      EventBus.emit('bewerten:vue:artikel:changed', articleId);
      if (doAdd2Cart.value) {
        EventBus.emit('bewerten:vue:layer:hide');
      }
      focusSizeHeadline();
      if (props.artikelMap) {
        const article = props.artikelMap[articleId] || {};
        trackSizeSelected(props.syan, articleId, article.vertriebsinfoId, article.colors?.aktiv?.farbId, article.outofstock);
      }
    }

    function openLayer(eventContext, add2CartAfterSizeSelection) {
      showLayer.value = true;
      doAdd2Cart.value = add2CartAfterSizeSelection;
      drawer.value.show();
      track({
        event_level1: 'ents',
        event_level2: null,
        event_level3: null,
        event_level4: null,
        event_level5: null,
        event: 'event.generic',
        event_values: [
          'click',
          'size_menu',
        ],
      });
      trackCubeCustomEvent('size_layer_open', {
        event_category: 'size_layer',
        is_interaction_event: true,
        event_type: 'open',
        event_context: eventContext,
      });
    }

    function closeLayer() {
      if (showLayer.value) {
        if (drawer.value.open) {
          drawer.value.hide();
        }
        showLayer.value = false;
        focusSizeHeadline();
      }
    }

    function focusSizeHeadline() {
      sizeHeadlineRef.value.focus();
      setTimeout(() => {
        // set focus again after a few seconds to make sure the dialog is already closed (else this won't work)
        // this might also be just a testcafe bug!
        sizeHeadlineRef.value.focus();
      }, 300);
    }

    onMounted(() => {
      EventBus.on(
        'bewerten:vue:sizes:highlight:show',
        add2CartAfterSizeSelection => openLayer('cart_size_menu', add2CartAfterSizeSelection),
      );
      drawer.value.addEventListener('drawer:close', () => {
        closeLayer();
      });
    });

    onBeforeMount(() => {
      document.addEventListener('ents:article:addtocart', closeLayer);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('ents:article:addtocart', closeLayer);
    });

    return {
      showLayer,
      doAdd2Cart,
      scrollPosition,
      groesseSelected,
      openLayer,
      closeLayer,
      drawer,
      sizeHeadlineRef
    };
  },
};
